export default "__VITE_ASSET__Doq7D2kf__"